var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p'),_c('h2',[_vm._v(" 初始化状态数组,显示创建结果 initSubscribe \"; ")]),_c('p')])
}]

export { render, staticRenderFns }